<ng-template #cardTemplate>
  @for (item of items | async; track item) {
    <eas-booking-item-slot [bookingItem]="item"></eas-booking-item-slot>
  }
</ng-template>

<app-list title="Booking items" i18n-title
  [cardTemplate]="cardTemplate"
  [actions]="actions"
></app-list>
